<script>
import modalDeleteRole from "../../components/modals/modal-delete-role.vue";
import createUserRoleSidebar from "./setting-create-user-role-sidebar";
import _ from 'lodash';

export default {
  name: "usersRoles",
  components: {
    createUserRoleSidebar,
    modalDeleteRole,
  },
  methods: {
    loadUserRoles: async function (preventEvent) {
      this.roles = await this.$A.RoleService.GetRoles() || [];
      if (!preventEvent) {
        this.$emit("updated", this.roles);
      }
    },
    editUserRole: function (role) {
      this.$refs.userRoleEditor.edit(role);
    },
    duplicateUserRole: function (role) {
      let newRole = {...role, id: 0};
      newRole.name = newRole.name + ' copy';
      this.$refs.userRoleEditor.edit(newRole);
    },
    createUserRole: function () {
      console.log("waiting for create user role api....");
    },
    deleteUserRole: async function (role) {
      this.$refs.deleteRoleModal.open(role, this.roles);
    },
    canBeDeleted: function (role) {
      return !['Admin', 'User'].includes(role.name);
    },
    isAdmin: function (role){
      return role.proofPermissions === 3
          && role.manageUsers
          && role.manageAccount
          && role.manageBilling
    }
  },
  computed: {
    canCreateUserRole: function () {
      const userLimit = _.get(this, '$A.Auth.account.subscriptionState.userLimit', 0);
      return !userLimit || this.users.length < userLimit;
    },
    hasMoreThanOneAdminRole: function () {
      const adminRoles = this.roles.filter(this.isAdmin);
      return adminRoles.length > 1;
    }
  },
  data() {
    return {
      roles: [],
      users: []
    };
  },
  async mounted() {
    await this.loadUserRoles(true);
    this.users = await this.$A.AccountService.All() || [];
  },
};
</script>

<template>
  <div class="settings-card">
    <div class="card-head">
      <div class="card-head-title">User Roles</div>
      <div class="card-head-subtitle">Create and manage custom user roles for your organization.</div>
    </div>

    <div class="role-rows">
      <div class="role-row" v-for="role in roles" :key="role.id">
        <div class="role-main">
          <span class="role-name">{{ role.name }}</span>
          <span v-if="isAdmin(role)" class="role-chip chip-admin">Admin access</span>
          <span v-if="!canBeDeleted(role)" class="role-chip">Built-in</span>
        </div>
        <span class="row-actions">
          <a class="action-link" @click="editUserRole(role)"
             v-if="!isAdmin(role) || hasMoreThanOneAdminRole">Edit</a>
          <a class="action-link" @click="duplicateUserRole(role)"
             v-if="canCreateUserRole">Duplicate</a>
          <a v-if="canBeDeleted(role)" class="action-link action-danger"
             @click="deleteUserRole(role)">Delete</a>
        </span>
      </div>
    </div>

    <modal-delete-role ref="deleteRoleModal" @deleted="loadUserRoles"/>

    <div class="card-foot">
      <a v-if="canCreateUserRole"
         @click="createUserRole()"
         v-b-toggle.create-user-role-sidebar
         class="primary-btn"
      >Create User Role</a>
      <button
          v-if="!canCreateUserRole"
          class="locked-btn"
          @click="$A.BuyNow()"
          v-b-tooltip.hover="'Upgrade to create custom user roles'"
      >
        Feature Locked <img src="/img/feature-lock.svg" class="feature-icon ml-2"/>
      </button>
      <create-user-role-sidebar ref="userRoleEditor" @saved="loadUserRoles"/>
    </div>
  </div>
</template>

<style scoped>
.settings-card {
  background: #fff;
  border: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.04), 0 8px 24px -16px rgba(8, 11, 13, 0.1);
}
.card-head {
  padding: 14px 20px;
  background: #fbfbfc;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 12px 12px 0 0;
}
.card-head-title {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
}
.card-head-subtitle {
  margin-top: 1px;
  font-size: 12.5px;
  font-weight: 400;
  color: #6b7280;
}
.card-foot {
  display: flex;
  justify-content: flex-end;
  padding: 12px 20px;
  background: #fbfbfc;
  border-top: 1px solid rgba(15, 23, 42, 0.06);
  border-radius: 0 0 12px 12px;
}

/* Rows */
.role-row {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 13px 20px;
  border-bottom: 1px solid rgba(15, 23, 42, 0.06);
  transition: background-color 120ms ease;
}
.role-row:hover {
  background: #f9f9fa;
}
.role-row:last-child {
  border-bottom: 0;
}
.role-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.role-name {
  font-size: 13.5px;
  font-weight: 500;
  color: #111827;
}
.role-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 10px;
  border-radius: 999px;
  background: #f3f4f6;
  color: #4b5563;
  font-size: 11px;
  font-weight: 600;
}
.chip-admin {
  background: rgba(1, 146, 86, 0.1);
  color: #017a48;
}
.row-actions {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 14px;
}
.action-link {
  font-size: 12.5px;
  font-weight: 600;
  color: #019256;
  cursor: pointer;
  text-decoration: none;
}
.action-link:hover {
  color: #017a48;
  text-decoration: none;
}
.action-danger {
  color: #b43643;
}
.action-danger:hover {
  color: #8f2a35;
}

/* Buttons */
.primary-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 18px;
  background: #019256;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  transition: background-color 120ms ease;
}
.primary-btn:hover {
  background: #017a48;
  color: #fff;
  text-decoration: none;
}
.locked-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 36px;
  padding: 0 16px;
  background: #F44271;
  border: 0;
  color: #fff;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(8, 11, 13, 0.05);
}
.locked-btn:hover {
  opacity: 0.9;
}
.feature-icon {
  height: 14px;
}

@media (max-width: 575px) {
  .role-row {
    flex-wrap: wrap;
    gap: 8px;
  }
  .role-main {
    flex-basis: 100%;
  }
  .row-actions {
    margin-left: auto;
  }
  .primary-btn,
  .locked-btn {
    flex: 1;
  }
}
</style>
